import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client from '../api/client';

export default function LandingPage() {
  const [facts, setFacts] = useState(null);

  useEffect(() => {
    client
      .get('/public/exam-facts')
      .then(({ data }) => setFacts(data))
      .catch(() => setFacts(null));
  }, []);

  return (
    <>
      <header className="hero">
        <div className="container">
          <div className="eyebrow">PMI PMP® exam prep</div>
          <h1>Revise for the PMP the way the exam is actually built.</h1>
          <p className="lead">
            A study assistant grounded in the current Exam Content Outline — the blueprint every
            question maps to. Ask questions, drill scenarios, take mock exams, and track your
            confidence across all three domains.
          </p>
          <div className="row wrap" style={{ marginTop: 22 }}>
            <Link to="/register" className="btn btn-accent">Create your account</Link>
            <Link to="/login" className="btn btn-ghost" style={{ color: '#fff', borderColor: 'rgba(255,255,255,.3)' }}>
              Sign in
            </Link>
          </div>
        </div>
      </header>

      <main className="container" style={{ marginTop: 40 }}>
        {/* Domain weights */}
        <section className="card card-pad-lg">
          <div className="row-between wrap">
            <div>
              <span className="pill pill-amber">Current ECO — effective 9 July 2026</span>
              <h2 style={{ marginTop: 10 }}>What the exam weighs</h2>
              <p className="muted small">
                The 2026 outline rebalanced the domains. Business Environment grew sharply, and
                roughly 60% of the exam now reflects agile and hybrid ways of working.
              </p>
            </div>
          </div>
          <div className="divider" />
          <div className="weights">
            {(facts?.domains || [
              { key: 'people', label: 'People', weight: 33 },
              { key: 'process', label: 'Process', weight: 41 },
              { key: 'business-environment', label: 'Business Environment', weight: 26 },
            ]).map((d) => (
              <div className="weight-row" key={d.key}>
                <div className="small" style={{ fontWeight: 600 }}>{d.label}</div>
                <div className="bar"><span style={{ width: `${d.weight}%` }} /></div>
                <div className="small" style={{ fontWeight: 700, textAlign: 'right' }}>{d.weight}%</div>
              </div>
            ))}
          </div>
          {facts?.exam && (
            <p className="tiny muted" style={{ marginTop: 16 }}>
              Exam format: {facts.exam.totalQuestions} questions in {facts.exam.minutes} minutes,
              {' '}{facts.exam.breaks} breaks, closed-book. (~{facts.exam.scoredQuestions} scored +
              {' '}{facts.exam.pretestQuestions} pretest.)
            </p>
          )}
        </section>

        {/* Features */}
        <section className="grid-3" style={{ marginTop: 24 }}>
          <div className="card">
            <span className="pill">Grounded assistant</span>
            <h3 style={{ marginTop: 12 }}>Answers you can trust</h3>
            <p className="muted small">
              Every reply is grounded in indexed, ECO-aligned material and scoped to PMP only.
              No cheating, no "brain dumps" — PMI doesn't publish past papers, and neither do we.
            </p>
          </div>
          <div className="card">
            <span className="pill">Scenario drills</span>
            <h3 style={{ marginTop: 12 }}>Practice judgement</h3>
            <p className="muted small">
              The PMP tests what you'd DO, not what you memorised. Work original scenario
              questions and see why the best answer is best.
            </p>
          </div>
          <div className="card">
            <span className="pill">Track progress</span>
            <h3 style={{ marginTop: 12 }}>Know your weak spots</h3>
            <p className="muted small">
              Rate your confidence by topic and domain, take timed mocks, and focus your final
              weeks where they count.
            </p>
          </div>
        </section>

        {/* How to register */}
        <section className="card card-pad-lg" style={{ marginTop: 24 }}>
          <h2>Getting started</h2>
          <ol className="muted small" style={{ lineHeight: 1.9 }}>
            <li>Create an account and pick a study focus (or "all domains").</li>
            <li>Verify your email with the 6-digit code we send you.</li>
            <li>Sign in — we'll email a one-time code for secure two-step sign-in.</li>
            <li>Start asking the assistant, drilling mocks, and tracking progress.</li>
          </ol>
          <div className="row wrap" style={{ marginTop: 8 }}>
            <Link to="/register" className="btn btn-primary">Create your account</Link>
            <Link to="/terms" className="btn btn-ghost">Read the terms</Link>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container row-between wrap">
          <div>PMP Revise — an independent study aid. Not affiliated with or endorsed by PMI.</div>
          <div><Link to="/terms">Terms &amp; conditions</Link></div>
        </div>
      </footer>
    </>
  );
}
